export default __webpack_public_path__ + "static/media/credit-card.feeaa4ce.svg";